module dg.loading {

    function dgView($timeout): ng.IDirective {
            return {
                restrict: 'A',
                scope: false,
                transclude: true,
                templateUrl: '/digmo/src/loading/dg-view.html',
                controller: function ($scope) {
                }
            };
        }

        angular.module('dg.loading')
            .directive('dgView', dgView);
    }